import type { Slide } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { BaseSceneSwapBridge } from 'js/src/libs/scene-swapping/BaseBridge';
import { isAIAvatarSceneGroup, isTalkingHeadSceneGroup } from 'js/src/luminary';

export class CommonToTalkingHeadInsertBridge extends BaseSceneSwapBridge {
    override _from = VideoData.CATEGORY_COMMON;
    override _to = VideoData.CATEGORY_TALKING_HEAD_INSERT;

    override _isSwapAllowedFor(originalScene: Slide): boolean {
        // you can swap a common scene to a talking head insert scene if the common scene is being
        // used as a part of a talking head or AI avatar scene group
        return (
            isTalkingHeadSceneGroup(originalScene.sceneGroup) ||
            isAIAvatarSceneGroup(originalScene.sceneGroup)
        );
    }
}
